const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api`

let onUnauthorized = null

export const setUnauthorizedHandler = (callback) => {
    onUnauthorized = callback
}

const request = async (path, options = {}, allowUnauthorized = false) => {
    const res = await fetch(`${BASE_URL}${path}`, {
        headers: {
            "Content-Type": "application/json",
            ...(options.headers || {})
        },
        ...options
    })

    if (((res.status === 401 || res.status === 440) && !allowUnauthorized) && typeof onUnauthorized === "function") onUnauthorized()

    return res
}

export const api = {
    get: (path) => request(path),
    post: (path, body, allowUnauthorized = false) =>
        request(path, {
            method: "POST",
            body: JSON.stringify(body)
        }, allowUnauthorized),
    put: (path, body, allowUnauthorized = false) =>
        request(path, {
            method: "PUT",
            body: JSON.stringify(body)
        }, allowUnauthorized),
    delete: (path, allowUnauthorized = false) =>
        request(path, {
            method: "DELETE"
        }, allowUnauthorized)
}
